/**
 * @license
 * Copyright (c) 2018 Crius Authors. All rights reserved.
 */

import '@polymer/polymer/polymer-element.js';

const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `
<dom-module id="cs-shared-styles-base-links">
	<template>
		<custom-style>
			<style>
        a,
        a:hover {
            color: var(--cs-theme-color);
            text-decoration: none;
            transition: var(--cs-interface-expansion)
        }

        :host([wf-loading]) a {
            opacity: 0
        }
        </style>
		</custom-style>
	</template>
</dom-module>`;

document.head.appendChild($_documentContainer.content);